import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useAuth } from "@/utils/auth";
import { isAdminEmail } from "@/utils/admin";

const landingLinks = [{ label: "Builder", href: "/builder", testId: "nav-builder-link" }];

const appLinks = [
  { label: "Home", to: "/", testId: "nav-home-link" },
  { label: "Builder", to: "/builder", testId: "nav-builder-link" },
  { label: "Admin", to: "/admin", testId: "nav-admin-link" },
];

export const SiteNav = ({ mode = "landing" }) => {
  const isLanding = mode === "landing";
  const { isAuthenticated, user, loginWithRedirect, logout } = useAuth();
  const isAdmin = isAdminEmail(user?.email);

  return (
    <nav className="sticky top-0 z-40 border-b-2 border-black bg-white/90 backdrop-blur-md" data-testid="site-nav">
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between gap-6 px-6 py-4">
        <Link to="/" className="flex flex-col leading-tight" data-testid="nav-brand-link">
          <span
            className="text-xl font-bold uppercase tracking-[0.2em] text-primary"
            data-testid="nav-brand-title"
          >
            Custom Box Lab
          </span>
          <span
            className="text-[10px] font-semibold uppercase tracking-[0.3em] text-primary/60"
            data-testid="nav-brand-subtitle"
          >
            Crafted by Tailored Packaging
          </span>
        </Link>

        <div className="hidden items-center gap-6 md:flex">
          {isLanding
            ? landingLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className={cn(
                    "text-sm font-semibold uppercase tracking-[0.18em] text-primary/70 transition-colors hover:text-primary",
                  )}
                  data-testid={link.testId}
                >
                  {link.label}
                </a>
              ))
            : appLinks
                .filter((link) => (link.label === "Admin" ? isAdmin : true))
                .map((link) => (
                  <Link
                    key={link.label}
                    to={link.to}
                    className="text-sm font-semibold uppercase tracking-[0.18em] text-primary/70 transition-colors hover:text-primary"
                    data-testid={link.testId}
                  >
                    {link.label}
                  </Link>
                ))}

          {isLanding && isAdmin ? (
            <Link
              to="/admin"
              className="text-sm font-semibold uppercase tracking-[0.18em] text-primary/70 transition-colors hover:text-primary"
              data-testid="nav-admin-link"
            >
              Admin
            </Link>
          ) : null}
        </div>

        <div className="flex items-center gap-3">
          {!isAuthenticated ? (
            <Button
              type="button"
              variant="outline"
              className="h-11 rounded-none border-2 border-black px-4 text-xs font-semibold uppercase tracking-[0.3em]"
              onClick={() => loginWithRedirect()}
              data-testid="nav-login-button"
            >
              Log in
            </Button>
          ) : (
            <Button
              type="button"
              variant="outline"
              className="h-11 rounded-none border-2 border-black px-4 text-xs font-semibold uppercase tracking-[0.3em]"
              onClick={() => logout({ logoutParams: { returnTo: window.location.origin } })}
              data-testid="nav-logout-button"
            >
              Log out
            </Button>
          )}

          <Link to="/builder" data-testid="nav-quote-link">
            <Button
              className="h-11 rounded-none border-2 border-black bg-primary px-6 text-xs font-bold uppercase tracking-[0.3em] text-primary-foreground shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] transition-transform duration-200 hover:-translate-y-0.5"
              data-testid="nav-quote-button"
            >
              Get Instant Quote
            </Button>
          </Link>
        </div>
      </div>
    </nav>
  );
};
